/** @format */

export enum DynamicCategoryTemplateModules {
  CHECK_BACK = 'check_back',
  ONE_SPOT = 'One Spot',
  ONE_SPOT_WITH_DEALS = 'onespot_with_deals',
  THREE_SPOT = 'Three Spot',
  THREE_SPOT_WITH_DEALS = 'threespot_with_deals',
  NO_CONTENT = 'no_content',
}
